;(function () {

var SliderView = require('../views/slider');

var PageView = Backbone.View.extend({
  initialize: function () {
    // console.log('init search page');

    new SliderView({ el: this.$el.find('.slider.desktop'), group: 3 });    
    new SliderView({ el: this.$el.find('.slider.mobile') });
  }
});

module.exports = PageView;

}());